import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import Title from './Title'
import { resolveDifferenceOfAverage } from '../utils/averageResolver'
import selectEntireColumn from '../utils/columnSelector'
import selectEntireRow from '../utils/rowSelector'

const RowAverageDiff = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  const selectedRow = selectEntireRow(detailSetting, crossTabs)
  const selectedItem = selectEntireColumn(detailSetting, selectedRow)
  const differenceOfAverage = resolveDifferenceOfAverage(detailSetting, selectedRow, selectedItem)

  return (
    <UnexpectedErrorBoundary>
      <Overview title={<Title />} count={differenceOfAverage} status="succeeded" />
    </UnexpectedErrorBoundary>
  )
}

export default RowAverageDiff
